import { useQuery } from '@apollo/client';
import { useLingui } from '@lingui/react';
import { Input, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { GQL_GET_ONE_PROJECT } from '~/gql/project/project';
import { authClient } from '~/helpers/apollo';
//import { useAuth } from '~/helpers/store/auth';
import useDataUserStore from '~/helpers/store/data-user/data-user';
import MaintenanceTable from '~/pages/components/common/maintenance/MaintenanceTable';
import DefaultLayout from '~/pages/layouts/DefaultLayout';
import ManagerLayout from '~/pages/layouts/ManagerLayout';
import { classic } from '~/themes';

function MaintenancePage() {
  const params = useParams();
  //const { payload } = useAuth();
  const { id } = params;
  const { i18n } = useLingui();
  const { Text } = Typography;
  const { currentProject, setCurrentProject } = useDataUserStore();
  const [loading, setLoading] = useState<boolean>(false);
  const [projectName, setProjectName] = useState<string>('');

  const { refetch: fetchProject } = useQuery(GQL_GET_ONE_PROJECT, {
    variables: {
      id: Number(id),
    },
    client: authClient,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      setCurrentProject(data.getOneProject);
      setProjectName(data.getOneProject.name);
    },
    onError: (e) => {
      console.log('erreur dans GQL_GET_ONE_PROJECT', e);
    },
  });

  useEffect(() => {
    if (!currentProject) {
      void getProject();
    }

    if (currentProject) {
      setProjectName(currentProject.name);
    }
  }, []);

  async function getProject() {
    setLoading(true);
    await fetchProject();
    setLoading(false);
  }

  return (
    <>
      <DefaultLayout>
        <ManagerLayout>
          {loading ? (
            <p>{i18n._('common.loading')} ...</p>
          ) : (
            <>
              <SDivContentWrapper>
                <SDivTitle>
                  <Text style={{ marginRight: '10px' }}>
                    {i18n._('form.project-name')}
                  </Text>
                  <Input
                    style={{ width: '250px', marginRight: '10px' }}
                    placeholder={i18n._('form.project-name.placeholder')}
                    value={projectName}
                  />
                  <Text style={{ margin: '10px' }}>
                    {i18n._('form.project.manager')}
                  </Text>
                  <Text
                    style={{
                      fontWeight: 'bold',
                      color: classic.token?.colorPrimary,
                    }}
                  >
                    {currentProject?.projectManager.firstName +
                      ' ' +
                      currentProject?.projectManager.lastName}
                  </Text>
                </SDivTitle>
              </SDivContentWrapper>
              <SDivDevisWrapper>
                <MaintenanceTable />
              </SDivDevisWrapper>
            </>
          )}
        </ManagerLayout>
      </DefaultLayout>
    </>
  );
}

export default MaintenancePage;

const SDivContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const SDivTitle = styled.div`
  align-items: center;
  display: flex;
  width: 100%;
`;

const SDivDevisWrapper = styled.div`
  display: flex;
`;
